import { useCallback } from 'react';
import type { MessageDeliveryStatus, MessagePlaceholderDataObject } from '#models/services';

type CreatePlaceholderMessage = {
  chatroomId: string;
  messageId: string;
  payload?: MessagePlaceholderDataObject['payload'];
  status: MessageDeliveryStatus;
  text?: string;
};

export const useCreatePlaceholderMessage = () =>
  useCallback(
    ({ chatroomId, messageId, payload, status, text }: CreatePlaceholderMessage): MessagePlaceholderDataObject => {
      const now = new Date().toISOString();

      return {
        _id: messageId,
        chatroom: chatroomId,
        createdAt: now,
        payload: payload ?? [],
        status,
        text,
        type: 'message-placeholder',
        updatedAt: now,
      };
    },
    [],
  );
